import React from 'react';
import { useFeedback } from '../../context/FeedbackContext';

/**
 * "Share feedback →" link rendered at the bottom of the mobile bottom-sheet
 * body in both Explorer and Detail. Mobile-only (`md:hidden`) — desktop
 * users already have the persistent corner pill. Without this, a mobile
 * user who dismissed the auto-prompt has no path back to the form short
 * of clearing storage or hitting `?feedback=1`.
 *
 * Visual language matches the panel's other meta-links ("What is this?",
 * "Run a guided scenario") so it reads as part of the same family of
 * footer affordances rather than a foreign CTA.
 */
export const FeedbackPanelLink: React.FC = () => {
  const { openSurvey } = useFeedback();
  return (
    <div className="md:hidden border-t border-figma-lime/20 pt-5">
      <button
        type="button"
        onClick={openSurvey}
        className="text-left text-[13px] font-roboto text-figma-mint hover:text-figma-lime focus:outline-none focus-visible:underline transition-smooth"
      >
        Share feedback &rarr;
      </button>
      <p className="mt-1.5 text-[11px] font-roboto text-figma-ink-mute">
        Tell us what worked and what to improve. Opens in a new tab.
      </p>
    </div>
  );
};
